"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/** @hidden */
exports.assert = function (condition, message) {
    if (!condition) {
        throw new Error(message);
    }
};
//# sourceMappingURL=assert.js.map


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/Angular_wig_cropmap_master/node_modules/@angular-redux/store/lib/src/utils/assert.js
// module id = ../../../../@angular-redux/store/lib/src/utils/assert.js
// module chunks = vendor